// src/components/EventMenuComponent.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

import {
    IconHotelService,
    IconCalendarCheck,
} from '@tabler/icons-react';

import './MenuComponent.css';


/* =========================================
   TYPES
   ========================================= */

interface HotelMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    icon: React.ReactNode;
    link: string;
}

interface EventMenuProps {
    eventID?: number;
    itemsToShow?: number[];
}


/* =========================================
   MENU ITEMS
   ========================================= */

const defaultEventMenuItems: HotelMenuItem[] = [
    {
        id: 1,
        titleEn: 'Manage Hotel',
        titleDa: 'Administrér Hotel',
        icon: <IconHotelService />,
        link: '/admin/hotels',
    },
    {
        id: 2,
        titleEn: 'Hotel Booking',
        titleDa: 'Hotel Booking',
        icon: <IconCalendarCheck />,
        link: '/admin/hotel-bookings',
    },
];


/* =========================================
   COMPONENT
   ========================================= */

const HotelMenuComponent: React.FC<EventMenuProps> = ({
    eventID,
    itemsToShow,
}) => {

    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultEventMenuItems.filter((item) =>
            itemsToShow.includes(item.id)
        )
        : defaultEventMenuItems;


    return (
        <div className="menu-container">

            <section className="menu-section">

                <div className="menu-section-header">
                    <h2 className="menu-section-title">
                        {language === 'da'
                            ? 'Hotel'
                            : 'Hotel'}
                    </h2>

                    <span className="menu-section-count">
                        {filteredMenuItems.length}
                    </span>
                </div>


                <div className="menu-grid">

                    {filteredMenuItems.map((item) => {

                        const title =
                            language === 'da'
                                ? item.titleDa
                                : item.titleEn;

                        const link = eventID
                            ? `${item.link}/${eventID}`
                            : item.link;


                        return (
                            <Link
                                key={item.id}
                                to={link}
                                className="menu-card"
                            >

                                <div className="menu-card-content">

                                    <div className="menu-icon">
                                        {item.icon}
                                    </div>

                                    <div className="menu-card-text">

                                        <div className="menu-title">
                                            {title}
                                        </div>

                                    </div>

                                </div>

                            </Link>
                        );
                    })}

                </div>

            </section>

        </div>
    );
};

export default HotelMenuComponent;